import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../components/presentation/Text'
import BucketForm from './BucketForm'
import ControlledModal from '../../../components/modals/ControlledModal'
import Separator from '../../../components/helpers/Separator'

const EditBucketModal = props => {
  const { t } = useTranslation('editBucket')

  return (
    <ControlledModal width="28rem" {...props}>
      <Title size="h4">{t('title')}</Title>
      <Separator weight={6} />
      <BucketForm />
    </ControlledModal>
  )
}

export default EditBucketModal
